var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgControlview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(-600 -2017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    transform: "translate(600 2017)",
    fill: "none",
    stroke: "#999",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "videocam_FILL0_wght400_GRAD0_opsz24",
    d: "M82.8-777.6a2.7,2.7,0,0,1-1.978-.823A2.7,2.7,0,0,1,80-780.4v-16.8a2.7,2.7,0,0,1,.822-1.978A2.7,2.7,0,0,1,82.8-800H99.6a2.7,2.7,0,0,1,1.978.822,2.7,2.7,0,0,1,.822,1.978v6.3l5.6-5.6v15.4l-5.6-5.6v6.3a2.7,2.7,0,0,1-.822,1.977,2.7,2.7,0,0,1-1.978.823Zm0-2.8H99.6v-16.8H82.8Zm0,0v0Z",
    transform: "translate(538 2835.8)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlview);
export default __webpack_public_path__ + "static/media/controlview.bdaef6e2d5da6aff7ff58d6183b6e076.svg";
export { ForwardRef as ReactComponent };